import { IFormActualsTargetsSettings } from 'legacy/lut/classes/models/partner360/IFormActualsTargetsSettings'

import { OVERALL_CATEGORY } from '../../config'
import { IPartnerFlag } from '../../models/IPartnerFlag'

import { cleanSettingFlag } from './cleanSettingFlag'

export const isPartnerFlagActive = (
  partnerFlags: IPartnerFlag[],
  settings: IFormActualsTargetsSettings[],
  category: string,
  isCheckParentAlso = false,
  isCheckUnitsOnly = false,
  isCheckSobOnly = false
) => {
  // Settings flags
  const settingsFlags: string[] = []

  settings.forEach((setting) => {
    const isChildSetting =
      setting.Category === category &&
      setting.SubCategory !== OVERALL_CATEGORY &&
      setting.SubCategory

    const mandatoryByFlags = (setting.MandatoryByFlags || '').split(',')
    const unitsMandatoryByFlags = (setting.UnitsMandatoryByFlags || '').split(',')
    const sobMandatoryByFlags = (setting.SOBMandatoryByFlags || '').split(',')

    let allSettingFlags: string[] = []
    if (isCheckSobOnly) {
      allSettingFlags = sobMandatoryByFlags
    } else if (isCheckUnitsOnly) {
      allSettingFlags = unitsMandatoryByFlags
    } else {
      allSettingFlags = [...mandatoryByFlags, ...unitsMandatoryByFlags, ...sobMandatoryByFlags]
    }

    allSettingFlags
      .filter((el) => !!el)
      .forEach((settingFlag) => {
        settingFlag = cleanSettingFlag(settingFlag)

        const isFlagExist = settingsFlags.some((el) => el === settingFlag)
        if (!isFlagExist && (isChildSetting || isCheckParentAlso)) {
          settingsFlags.push(settingFlag)
        }
      })
  })

  // Partner flags
  const enabledPartnerFlags = partnerFlags.filter((el) => el.isEnabled).map((el) => el.name)

  const isAnyFlagsActive = settingsFlags.some((setting) => enabledPartnerFlags.includes(setting))

  return isAnyFlagsActive
}
